import React from "react";
import { CellItem, IconAvatar } from "../components";
import { ChevronRightOutline, KeyOutline } from "../icons";
export const DatasetAccessKeyCellItem = (props) => {
    return (React.createElement(CellItem, Object.assign({ startNode: React.createElement(IconAvatar, { size: "sm", square: true },
            React.createElement(KeyOutline, { size: "md" })), endNode: React.createElement(ChevronRightOutline, null), title: "Have a dataset access key?", subtitle: "Unlock dataset with access key", slotProps: {
            subtitle: {
                sx: {
                    color: (theme) => theme.palette.disabled.onContainer,
                },
            },
        } }, props)));
};
//# sourceMappingURL=DatasetAccessKeyCellItem.js.map